"use client";

export default function SegmentedToggle<T extends string>({
  options,
  value,
  onChange,
}: {
  options: { value: T; label: string }[];
  value: T;
  onChange: (v: T) => void;
}) {
  return (
    <div className="inline-flex rounded-full border border-gray-200 bg-white p-0.5 text-[11px] sm:text-xs shadow-sm shrink-0">
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => onChange(opt.value)}
          className={`px-2.5 sm:px-3 py-1 rounded-full font-medium transition-colors cursor-pointer
            ${value === opt.value ? "bg-blue-600 text-white" : "text-gray-500 hover:text-gray-700"}`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
